// 都道府県とリードタイムを紐付けるための設定ファイル。
// 都道府県ID:リードタイム（日数）
window.CustomDeliveryDatetime.settings.LEAD_TIMES.NORMAL = {
    1:6,
    2:3,
    3:3,
    4:3,
    5:3,
    6:3,
    7:3,
    8:5,
    9:5,
    10:5,
    11:5,
    12:5,
    13:5,
    14:5,
    15:3,
    16:3,
    17:3,
    18:3,
    19:3,
    20:3,
    21:5,
    22:5,
    23:5,
    24:5,
    25:5,
    26:5,
    27:5,
    28:5,
    29:5,
    30:5,
    31:3,
    32:3,
    33:3,
    34:3,
    35:3,
    36:3,
    37:3,
    38:3,
    39:3,
    40:3,
    41:3,
    42:3,
    43:3,
    44:3,
    45:3,
    46:3,
    47:13,
};

// 関東在庫の場合に、減らすリードタイム
// 例:配送先東京都(13)の場合、通常（LEAD_TIMES.normal.13）で4日で、関東在庫の場合、（LEAD_TIMES.kanto.13）の設定の1を減らして3日になる。
// 都道府県ID:減算するリードタイム（日数）

window.CustomDeliveryDatetime.settings.LEAD_TIMES.KANTO = {
    8:0,
    9:0,
    10:0,
    11:0,
    12:0,
    13:0,
    14:0,
    21:0,
    22:0,
    23:0,
    24:0,
    25:0,
    26:0,
    27:0,
    28:0,
    29:0,
    30:0,
};
// 九州在庫の場合に、減らすリードタイム
// 関東在庫同様にマイナスする日数を設定する
// 都道府県ID:減算するリードタイム（日数）
window.CustomDeliveryDatetime.settings.LEAD_TIMES.KYUSHU = {
    26:0,
    27:0,
    28:0,
    29:0,
    33:0,
    34:0,
    35:0,
    40:0,
    41:0,
    42:0,
    43:0,
    44:0,
    45:0,
    46:0,
};
// 関東、九州両方に存在する在庫の場合に、減らすリードタイム
// 関東在庫同様にマイナスする日数を設定する
// 都道府県ID:減算するリードタイム（日数）
window.CustomDeliveryDatetime.settings.LEAD_TIMES.KANTO_KYUSHU = {
    8:0,
    9:0,
    10:0,
    11:0,
    12:0,
    13:0,
    14:0,
    21:0,
    23:0,
    22:0,
    24:0,
    25:0,
    26:0,
    27:0,
    28:0,
    29:0,
    30:0,
    33:0,
    34:0,
    35:0,
    40:0,
    41:0,
    42:0,
    43:0,
    44:0,
    45:0,
    46:0,
};
